import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
export const PlayerSearchResultAvatar = ({ playerSearchResult, size = 56, }) => {
    const displayName = `${playerSearchResult.firstName} ${playerSearchResult.lastName}`;
    const tooltip = (_jsx(Tooltip, { title: displayName, arrow: true, children: _jsx(Avatar, { src: playerSearchResult.picture ?? undefined, alt: displayName, sx: { width: size, height: size }, children: displayName.match(/\b(\w)/g)?.join("") }) }));
    return (_jsx(Link, { style: { textDecoration: "none" }, to: `/players/${playerSearchResult.id}/`, children: tooltip }, playerSearchResult.id));
};
